import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StatusCardComponent } from './components/status-card/status-card.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MapDataComponent } from './components/map-data/map-data.component';
import { AmChartsModule } from '@amcharts/amcharts3-angular';
import { TimelineDataComponent } from './components/timeline-data/timeline-data.component';
import { IncidentTypesComponent } from './components/incident-types/incident-types.component';
import { AutoModelComponent } from './components/auto-model/auto-model.component';
import { IncidentChartComponent } from './components/incident-chart/incident-chart.component';
import { ClaimDataComponent } from './components/claim-data/claim-data.component';
import {ChartModule, HIGHCHARTS_MODULES} from 'angular-highcharts';
import * as more from 'highcharts/highcharts-more.src';
import * as exporting from 'highcharts/modules/exporting.src';
import { FraudReportDataComponent } from './components/fraud-report-data/fraud-report-data.component';
import { FraudTimelineDataComponent } from './fraud-component/fraud-timeline-data/fraud-timeline-data.component';
import { FraudAutoModelComponent } from './fraud-component/fraud-auto-model/fraud-auto-model.component';
import { FraudIncidentChartComponent } from './fraud-component/fraud-incident-chart/fraud-incident-chart.component';
import { FraudIncidentTypesComponent } from './fraud-component/fraud-incident-types/fraud-incident-types.component';
import { FraudMapDataComponent } from './fraud-component/fraud-map-data/fraud-map-data.component';
import {MatSelectModule} from '@angular/material/select';
import {MatTableModule} from '@angular/material/table';
@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    StatusCardComponent,
    MapDataComponent,
    TimelineDataComponent,
    IncidentTypesComponent,
    AutoModelComponent,
    IncidentChartComponent,
    ClaimDataComponent,
    FraudReportDataComponent,
    FraudTimelineDataComponent,
    FraudAutoModelComponent,
    FraudIncidentChartComponent,
    FraudIncidentTypesComponent,
    FraudMapDataComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule , ReactiveFormsModule, BrowserAnimationsModule,
    AmChartsModule,
    ChartModule,
    MatSelectModule,
    MatTableModule
  ],
  providers: [{ provide: HIGHCHARTS_MODULES, useFactory: () =>  [ more, exporting ]} ] ,
  bootstrap: [AppComponent],
  schemas: [ NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
